import PropTypes from 'prop-types';
import React from 'react';
import { Modal, TFVButton } from '../../../Share/components';
import { isIE } from '../../../Share/utils';
import {
  DatePicker,
  MultiViewCalendar,
} from '@progress/kendo-react-dateinputs';
import moment from 'moment';

const SingleViewCalendar = props => <MultiViewCalendar {...props} views={1} />;

function DeleteUser({
  isVisible = false,
  onClose = () => {},
  onDeleteUser = () => {},
  selectedUser = null,
  dateFirstCancellationPossible = null,
}) {
  const [selectedDate, setSelectedDate] = React.useState(null);

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const maxDate = dateFirstCancellationPossible
    ? new Date(moment(dateFirstCancellationPossible).format('YYYY-MM-DD'))
    : new Date(moment().add(12, 'months').toDate());

  const isDateDisabled = date => {
    const dateToCheck = new Date(date);
    dateToCheck.setHours(0, 0, 0, 0);
    if (dateToCheck < today) return true;
    if (dateToCheck > maxDate) return true;
    return false;
  };

  const handleDeleteClick = () => {
    if (selectedDate) {
      onDeleteUser(selectedDate);
      setSelectedDate(null);
    }
  };

  const handleDateChange = e => {
    if (e.value && !isDateDisabled(e.value)) {
      setSelectedDate(e.value);
    }
  };

  return (
    <Modal
      isVisible={isVisible}
      onCloseClicked={() => {
        setSelectedDate(null);
        onClose();
      }}
      headerText="Sätt avslutsdatum"
      className="tv-create-license__modal tv-create-license-user__modal"
      headerClassName="tv-create-license__modal-header"
      ieOptionClassName={isIE ? 'ie-fix-height' : ''}
    >
      <p className="mb-4">Är du säker på att du vill ange slutdatum?</p>
      <div className="form-group">
        <label>Datum</label>
        <DatePicker
          value={selectedDate}
          onChange={handleDateChange}
          min={today}
          max={maxDate}
          placeholder="Välj Datum"
          calendar={SingleViewCalendar}
        />
      </div>
      <div className="justify-content-between tv-display-flex gap-4 tv-create-license__modal__footer mt-5">
        <TFVButton
          type="line-primary"
          buttonType="button"
          className="w-50"
          text="Stäng"
          onClick={() => {
            setSelectedDate(null);
            onClose();
          }}
        />
        <TFVButton
          type="secondary"
          buttonType="submit"
          className="w-50"
          text="Spara"
          onClick={handleDeleteClick}
          disabled={!selectedDate}
        />
      </div>
    </Modal>
  );
}

DeleteUser.propTypes = {
  isVisible: PropTypes.bool,
  onClose: PropTypes.func,
  onDeleteUser: PropTypes.func,
  selectedUser: PropTypes.shape({
    UserName: PropTypes.string,
  }),
  dateFirstCancellationPossible: PropTypes.string,
};

export default DeleteUser;
